var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyfs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.691,
    height: 39.199,
    viewBox: "0 0 41.691 39.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "immigration",
    transform: "translate(-0.61 -1.592)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30903",
    "data-name": "Path 30903",
    d: "M27.56,53.19v4.243c0,.773-.1.875-.88.875H8.172c-.748,0-.846-.1-.846-.861,0-1.369-.028-2.74.007-4.109A4,4,0,0,1,9.791,49.6c1.161-.544,2.353-1.022,3.537-1.513a.461.461,0,0,0,.356-.521c-.029-.521-.021-1.044,0-1.566a.469.469,0,0,0-.27-.464,7.241,7.241,0,0,1-3.551-6.35.62.62,0,0,0-.353-.625,2.13,2.13,0,0,1-.063-3.721c.093-.038.16-.241.164-.369.037-.987,0-1.979.093-2.959a7.52,7.52,0,0,1,6.268-6.448,7.8,7.8,0,0,1,5.724,1.418,3.224,3.224,0,0,0,.035-.326c0-1.059,0-2.118,0-3.176a2.205,2.205,0,0,1,2.32-2.311c1.169,0,2.338,0,3.559,0,0-.33-.007-.622,0-.913.014-.481.162-.637.643-.639,1.271-.008,2.542,0,3.811,0H43.076c.81,0,.9.092.9.9v.661h.8c.635,0,1.271,0,1.906,0A2.2,2.2,0,0,1,49,22.978q.007,5.486,0,10.971V50.722a2.237,2.237,0,0,1-2.46,2.471H27.558Zm16.418-31.5v.531c0,.683-.13.807-.822.807H28.336c-.573,0-.72-.149-.728-.729,0-.194,0-.387,0-.622-1.218,0-2.385,0-3.554,0A1.2,1.2,0,0,0,22.746,23c-.006,1.384-.009,2.767.008,4.151a.993.993,0,0,0,.21.559,7.047,7.047,0,0,1,1.565,3.422,21.191,21.191,0,0,1,.141,2.614,1.261,1.261,0,0,0,.628,1.312c1.222.746.986,2.735-.354,3.5a.572.572,0,0,0-.336.587,7.283,7.283,0,0,1-1.675,4.77.853.853,0,0,0-.181.488c-.015,1.284,0,2.569-.015,3.854a.42.42,0,0,0,.317.458c.653.264,1.3.549,1.945.827a3.993,3.993,0,0,1,2.208,2.221.573.573,0,0,0,.654.409q9.295-.01,18.59-.006c1.138,0,1.54-.407,1.54-1.563V23.253c0-.155.007-.311-.007-.465a1.124,1.124,0,0,0-1.012-1.082C45.99,21.662,45,21.693,43.979,21.693ZM26.544,57.263v-.44c0-1.129.017-2.257,0-3.387a3.082,3.082,0,0,0-1.953-2.955q-1.835-.815-3.692-1.573a.97.97,0,0,0-.633-.02,8.356,8.356,0,0,1-5.679-.015.784.784,0,0,0-.514,0c-1.314.545-2.634,1.078-3.923,1.679a2.965,2.965,0,0,0-1.8,2.789c-.026,1.185-.007,2.371,0,3.555,0,.122.014.244.021.361h18.18Zm-14.4-23.989c-.058.9-.105,1.713-.162,2.528a.653.653,0,0,1-1.006.6c-.268-.124-.532-.261-.788-.408-.41-.235-.646-.131-.751.347a1.233,1.233,0,0,0,.929,1.488.61.61,0,0,1,.5.672q-.007.445,0,.889A6.365,6.365,0,0,0,21.931,43.5,6.406,6.406,0,0,0,23.6,38.678a.748.748,0,0,1,.612-.9,1.194,1.194,0,0,0,.824-1.434.68.68,0,0,0-.78-.6,14.418,14.418,0,0,1-3.923.066,11.68,11.68,0,0,1-6.142-2.389.685.685,0,0,0-.373-.151c-.534-.017-1.068-.007-1.666-.007Zm11.462,1.548c0-1.066.083-2.073-.016-3.063a6.495,6.495,0,0,0-12.727-.971,16.559,16.559,0,0,0-.221,4.129c0,.11.163.224.25.336l.11-.059q.068-1.115.134-2.229c.029-.517.193-.662.7-.685,1.127-.05,2.259-.068,3.378-.19a13.938,13.938,0,0,0,5.053-1.444c.423-.223.811-.509,1.221-.758a.48.48,0,0,1,.707.124.472.472,0,0,1-.106.678,3.182,3.182,0,0,1-.269.2,12.016,12.016,0,0,1-4.171,1.792c-.682.163-1.374.29-2.15.452a12.916,12.916,0,0,0,8.1,1.683Zm5.037-12.834H42.933V20.157H28.646Zm-8.452,24.15a20.28,20.28,0,0,1-2.728.435,20.853,20.853,0,0,1-2.771-.27c0,.37-.016.836.011,1.3a.445.445,0,0,0,.247.31,7.052,7.052,0,0,0,4.968,0,.487.487,0,0,0,.261-.346c.029-.491.012-.986.012-1.428Zm1.527-.982a.787.787,0,0,0-.509.724c0,.562.027,1.127-.009,1.687-.026.41.2.474.518.54Z",
    transform: "translate(-6.705 -17.516)",
    fill: "#ff0089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30910",
    "data-name": "Path 30910",
    d: "M130.531,249.3v2.951c-.319-.066-.545-.13-.518-.54.036-.56.009-1.125.009-1.687A.787.787,0,0,1,130.531,249.3Z",
    transform: "translate(-115.517 -221.66)",
    fill: "#ff0089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30911",
    "data-name": "Path 30911",
    d: "M166.071,85.535a5.589,5.589,0,1,1,5.55,5.608,5.581,5.581,0,0,1-5.55-5.608Zm1.017.024a4.573,4.573,0,1,0,4.612-4.581,4.574,4.574,0,0,0-4.612,4.581Z",
    transform: "translate(-147.496 -71.481)",
    fill: "#ff0089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30912",
    "data-name": "Path 30912",
    d: "M247.536,215.264c1.072,0,2.142,0,3.214,0,.445,0,.7.192.672.514-.035.393-.311.5-.657.5h-6.427c-.345,0-.622-.105-.646-.507-.019-.334.213-.507.672-.508,1.057,0,2.114,0,3.172,0Z",
    transform: "translate(-216.333 -191.475)",
    fill: "#ff0089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30913",
    "data-name": "Path 30913",
    d: "M182.26,260.112c.874,0,1.747,0,2.621,0,.459,0,.683.182.664.521-.024.409-.307.495-.651.495-1.734,0-3.466,0-5.2,0-.439,0-.7-.2-.673-.522.037-.39.31-.5.66-.495.86,0,1.719,0,2.579,0Z",
    transform: "translate(-158.98 -231.246)",
    fill: "#ff0089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30914",
    "data-name": "Path 30914",
    d: "M299.417,166.657c.578,0,1.158,0,1.736,0,.42,0,.655.19.633.509-.025.368-.268.5-.608.5-1.171,0-2.344,0-3.515,0-.337,0-.59-.141-.584-.518s.261-.5.6-.5c.578,0,1.158,0,1.736,0Z",
    transform: "translate(-263.68 -148.366)",
    fill: "#ff0089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30915",
    "data-name": "Path 30915",
    d: "M300.178,90.98c.565,0,1.129,0,1.694,0,.347,0,.6.136.6.5s-.256.511-.6.513q-1.714.005-3.43,0c-.334,0-.594-.13-.593-.51s.252-.5.593-.5h1.736Z",
    transform: "translate(-264.364 -81.255)",
    fill: "#ff0089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30916",
    "data-name": "Path 30916",
    d: "M277.986,129.417c-.55,0-1.1.008-1.65,0-.4-.008-.652-.224-.619-.535.038-.367.285-.481.626-.48,1.113,0,2.228,0,3.342,0,.413,0,.665.2.642.5-.029.389-.3.511-.648.51h-1.692Z",
    transform: "translate(-244.733 -114.44)",
    fill: "#ff0089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30917",
    "data-name": "Path 30917",
    d: "M306.108,261.145h-1.354c-.343,0-.6-.143-.6-.5s.25-.51.6-.51h2.709c.342,0,.6.135.6.5s-.248.511-.592.511h-1.354Z",
    transform: "translate(-269.951 -231.264)",
    fill: "#ff0089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30918",
    "data-name": "Path 30918",
    d: "M181.034,215.271h1.352c.322,0,.561.122.577.474.017.376-.227.532-.565.536-.915.01-1.831.008-2.746,0-.322,0-.562-.166-.562-.5,0-.36.242-.51.592-.508.45,0,.9,0,1.352,0Z",
    transform: "translate(-159.043 -191.48)",
    fill: "#ff0089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30919",
    "data-name": "Path 30919",
    d: "M249.669,260.125c.437,0,.875,0,1.311,0,.329,0,.55.161.548.508s-.232.5-.557.5q-1.312.009-2.623,0c-.321,0-.561-.139-.57-.489-.009-.375.24-.517.579-.522.437-.007.875,0,1.312,0Z",
    transform: "translate(-219.958 -231.256)",
    fill: "#ff0089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30920",
    "data-name": "Path 30920",
    d: "M319.882,216.268a5.6,5.6,0,0,1-.676-.006.5.5,0,0,1,.05-.989c.423-.01.846-.009,1.27,0a.459.459,0,0,1,.488.479.466.466,0,0,1-.456.513,6.416,6.416,0,0,1-.677,0h0Z",
    transform: "translate(-282.91 -191.477)",
    fill: "#ff0089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30921",
    "data-name": "Path 30921",
    d: "M267.826,166.562a1.9,1.9,0,0,1,.668.017c.187.076.429.29.436.453a.634.634,0,0,1-.381.493,5.133,5.133,0,0,1-1.425,0c-.161-.023-.375-.3-.4-.491-.041-.272.172-.463.473-.476.21-.009.422,0,.633,0Z",
    transform: "translate(-236.753 -148.264)",
    fill: "#ff0089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30922",
    "data-name": "Path 30922",
    d: "M224.8,214.41a2.179,2.179,0,0,1,.612.446c.07.1-.057.506-.152.528a2.618,2.618,0,0,1-1.01.028c-.1-.018-.244-.326-.224-.482.051-.388.369-.45.712-.415Z",
    transform: "translate(-198.891 -190.718)",
    fill: "#ff0089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30923",
    "data-name": "Path 30923",
    d: "M285.453,260.13c.44,0,.691.182.694.5s-.252.51-.688.511-.688-.179-.689-.506.24-.509.685-.51Z",
    transform: "translate(-252.764 -231.264)",
    fill: "#ff0089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30924",
    "data-name": "Path 30924",
    d: "M327.636,129.426c-.416,0-.641-.18-.646-.506s.223-.513.674-.51c.42,0,.648.177.653.5S328.065,129.431,327.636,129.426Z",
    transform: "translate(-290.206 -114.449)",
    fill: "#ff0089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30925",
    "data-name": "Path 30925",
    d: "M276.373,90.98c.4,0,.647.192.646.5s-.255.509-.648.513c-.415,0-.68-.209-.665-.535s.248-.483.667-.481Z",
    transform: "translate(-244.725 -81.255)",
    fill: "#ff0089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30927",
    "data-name": "Path 30927",
    d: "M190.03,112.532c1.086-1.089,2.122-2.127,3.16-3.164.1-.1.2-.247.317-.267.187-.033.465-.048.565.06a.906.906,0,0,1,.112.6c0,.1-.148.2-.236.286q-1.691,1.694-3.383,3.385c-.415.414-.61.412-1.024,0s-.817-.819-1.229-1.227c-.246-.243-.326-.519-.069-.779a.5.5,0,0,1,.782.058c.326.333.645.671,1.007,1.048Z",
    transform: "translate(-167.019 -97.304)",
    fill: "#ff0089"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyfs);
export default __webpack_public_path__ + "static/media/eyfs.22dd72d90da9ffdc0d0c51626c7bb866.svg";
export { ForwardRef as ReactComponent };